import HubSpotCTA from './HubSpotCTA'
import ABN from './ABN'
import { planPrice } from 'common/utils/planPrice'
import { PlanSlug } from 'common/planSlugs'
import { Format } from 'common/utils'
import { THubSpotCTA } from 'common/cms-types'

type BlogPostProductCTAProps = {
  ctas: THubSpotCTA[]
}

const BlogPostProductCTA = ({ ctas }: BlogPostProductCTAProps) => {
  if (!ctas?.length) {
    return null
  }

  return (
    <ABN className='px-md-20' id='blogpost_product_cta'>
      {ctas.map(({ ctaId, href, imgSrc }) => (
        <HubSpotCTA key={ctaId} ctaId={ctaId}>
          <a href={href} target='_blank' rel='noopener noreferrer'>
            <img
              src={imgSrc}
              alt={`Find the right virtual office address for your business with plans starting from ${Format.money(
                planPrice.dailyOnYearlyPlan(PlanSlug.SCAN_LITE),
              )} a day`}
              loading='lazy'
              style={{ height: '100%', objectFit: 'fill', width: '100%' }}
              onError={(e) => (e.currentTarget.style.display = 'none')}
            />
          </a>
        </HubSpotCTA>
      ))}
    </ABN>
  )
}

export default BlogPostProductCTA
